import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import './signuppopup.css';
import api from '../../api/axios';
import { useTranslation } from 'react-i18next';

function SignUpPopUp(props) {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [userData, setUserData] = useState({
        vorname: '',
        nachname: '',
        alter: '',
        geburtstag: '',
        email: '',
        passwort: ''
    });

    const [registrationMessage, setRegistrationMessage] = useState('');
    const [vornameRegistrationMessage, setVornameRegistrationMessage] = useState('');
    const [nachnameRegistrationMessage, setNachnameRegistrationMessage] = useState('');
    const [alterRegistrationMessage, setAlterRegistrationMessage] = useState('');
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isVornameValid, setIsVornameValid] = useState(false);
    const [isNachnameValid, setIsNachnameValid] = useState(false);
    const [isAlterValid, setIsAlterValid] = useState(false);
    const [geburtstagRegistrationMessage, setGeburtstagRegistrationMessage] = useState('');
    const [isGeburtstagValid, setIsGeburtstagValid] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [passwordMatchMessage, setPasswordMatchMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    const passwortRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
    const nameRegex = /^[a-zA-Z\s]*$/;
    const alterRegex = /^[0-9]*$/;

    function validatePasswort(password) {
        return passwortRegex.test(password);
    }

    function validateVorname(vorname) {
        return nameRegex.test(vorname);
    }

    function validateNachname(nachname) {
        return nameRegex.test(nachname);
    }

    function validateAlter(alter) {
        return alterRegex.test(alter);
    }

    const calculateAge = (birthdate) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });

        if (name === "passwort") {
            const isValid = validatePasswort(value);
            setIsPasswordValid(isValid);
            if (!isValid) {
                setRegistrationMessage("Das Passwort muss mindestens acht Zeichen lang sein, einen Großbuchstaben und eine Zahl enthalten.");
            } else {
                setRegistrationMessage("");
            }
        } else if (name === "passwort2") {
            if (userData.passwort !== value) {
                setPasswordMatchMessage("Die Passwörter stimmen nicht überein.");
            } else {
                setPasswordMatchMessage("");
            }
        }
    };

    const handleVornameChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value });

        if (e.target.name === "vorname") {
            const isValid = validateVorname(e.target.value);
            setIsVornameValid(isValid);
            if (!isValid) {
                setVornameRegistrationMessage("Dein Vorname darf nur Buchstaben und Leerzeichen enthalten.");
            } else {
                setVornameRegistrationMessage("");
            }
        }
    };

    const handleNachnameChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value });

        if (e.target.name === "nachname") {
            const isValid = validateNachname(e.target.value);
            setIsNachnameValid(isValid);
            if (!isValid) {
                setNachnameRegistrationMessage("Dein Nachname darf nur Buchstaben und Leerzeichen enthalten.");
            } else {
                setNachnameRegistrationMessage("");
            }
        }
    };

    const handleGeburtstagChange = (e) => {
        const geburtstag = e.target.value;
        const age = calculateAge(geburtstag);
        const isValid = geburtstag !== ""; // Any selected date is valid
        setIsGeburtstagValid(isValid);
        setUserData({ ...userData, geburtstag, alter: age.toString() });

        if (!isValid) {
            setGeburtstagRegistrationMessage("Bitte wähle ein gültiges Datum.");
        } else {
            setGeburtstagRegistrationMessage("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);

        const form = e.target.closest('form');
        if (!form.checkValidity()) {
            // Let browser show validation UI
            form.reportValidity();
            return;
        }

        if (userData.passwort !== userData.passwort2) {
            setPasswordMatchMessage("Die Passwörter stimmen nicht überein.");
            return;
        }

        try {
            await api.post('/user/create', userData);
            const { passwort, passwort2, ...safeSignupData } = userData;
            sessionStorage.setItem('signupData', JSON.stringify(safeSignupData));
            // navigate('/profile'); // Removed: Do not redirect immediately
            // props.setTrigger(false); // Removed: Keep popup open to show message
            setIsSuccess(true);
        } catch (error) {
            console.error('Fehler beim User Registrieren:', error);
            setRegistrationMessage("Die Email existiert bereits.");
        }
    };

    const handleLoginClick = () => {
        props.setTrigger(false);
        props.setLoginTrigger(true);
    };

    return (props.trigger) ? (
        <div className="SignUpPopUp-class">
            <div className="SignUpPopUp-inner">
                <button className="close-btn-signup" onClick={() => props.setTrigger(false)}>&times;</button>
                {isSuccess ? (
                    <div className="signup-success-message">
                        <h2>{t('SuccessRegistration')}</h2>
                        <p>{t('PleaseCheckYourEmail')}</p>
                        <button className="signup-btn" onClick={() => props.setTrigger(false)}>{t('Close')}</button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        {props.children}
                        <div className="signup-txt">
                            <h2>{t('MeetMatch')} &#128101;</h2>
                        </div>
                        <div className="signup-input-container">
                            <label className="signup-label" htmlFor="vornameRegister">{t('Name')}</label>
                            <input
                                className="signup-input"
                                type="text"
                                id="vornameRegister"
                                name="vorname"
                                onChange={handleVornameChange}
                                required
                            />
                        </div>
                        <div className="signup-input-container">
                            <label className="signup-label" htmlFor="nachnameRegister">{t('FamilyName')}</label>
                            <input
                                className="signup-input"
                                type="text"
                                id="nachnameRegister"
                                name="nachname"
                                onChange={handleNachnameChange}
                                required
                            />
                        </div>
                        <div className="signup-input-container">
                            <label className="signup-label" htmlFor="geburtstagRegister">{t('Birthday')}</label>
                            <input
                                className="signup-input"
                                type="date"
                                id="geburtstagRegister"
                                name="geburtstag"
                                onChange={handleGeburtstagChange}
                                required
                            />
                        </div>
                        <div className="signup-input-container">
                            <label className="signup-label" htmlFor="emailRegister">{t('EMailAddress')}</label>
                            <input
                                className="signup-input"
                                type="email"
                                id="emailRegister"
                                name="email"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="signup-input-container">
                            <label className="signup-label" htmlFor="passwortRegister">{t('Password')}</label>
                            <input
                                className="signup-input"
                                type="password"
                                id="passwortRegister"
                                name="passwort"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="signup-input-container">
                            <label className="signup-label" htmlFor="passwortRegister2">{t('PasswordRepeat')}</label>
                            <input
                                className="signup-input"
                                type="password"
                                id="passwortRegister2"
                                name="passwort2"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="switch-to-login">
                            <p onClick={handleLoginClick}>{t('AlreadyAccount')}</p>
                        </div>
                        <button className="signup-btn" type="submit" disabled={!isPasswordValid && !isVornameValid && !isNachnameValid && !isAlterValid}>{t('Register')}</button>
                        <div className="registration-messages">
                            {isSubmitted && (
                                <>
                                    <p>{vornameRegistrationMessage}</p>
                                    <p>{nachnameRegistrationMessage}</p>
                                    <p>{geburtstagRegistrationMessage}</p>
                                    <p>{registrationMessage}</p>
                                    <p>{passwordMatchMessage}</p>
                                </>
                            )}
                        </div>
                    </form>
                )}
            </div>
        </div>
    ) : "";
}

export default SignUpPopUp